// Utility per costruire la URL del proxy immagini in modo sicuro (Electron compatibile)
import { apiUrl } from '../utils/apiBase';

export function getImageProxyUrl(rawUrl) {
  if (!rawUrl) return '';
  
  // 🔧 ELECTRON FIX: Evita ricorsione se l'URL è già un proxy completo
  if (rawUrl.includes('/proxy/image') || rawUrl.includes('localhost:')) {
    // Se è già un URL proxy completo, restituiscilo così com'è
    if (rawUrl.includes('/proxy/image') && rawUrl.includes('localhost:')) {
      return rawUrl;
    }
    // Se è un path relativo del proxy, aggiungici l'API base
    if (rawUrl.startsWith('/proxy/image')) {
      return apiUrl(rawUrl);
    }
    // Se contiene localhost ma non è un proxy, potrebbe essere un errore
    console.warn('[ELECTRON-DEBUG] Suspicious URL passed to getImageProxyUrl:', rawUrl);
    return rawUrl;
  }
  
  // Altrimenti costruisci la URL proxy
  return apiUrl(`/proxy/image?url=${encodeURIComponent(rawUrl)}`);
}
